// eslint-disable-next-line @typescript-eslint/no-unused-vars,prettier/prettier
import { createAction } from '@reduxjs/toolkit';

import uiSlice from './slice';

const actions = {
  ...uiSlice.actions,
  fetchTheme: createAction('ui/fetchTheme'),
  // INJECT
};

export const uiActions: typeof actions = actions;
